import { render } from "./Discounts.vue?vue&type=template&id=03ae1a7e&ts=true"
import script from "./Discounts.vue?vue&type=script&lang=ts"
export * from "./Discounts.vue?vue&type=script&lang=ts"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__